<template>
    <uv-popup
        :z-index="zIndex"
        :overlayStyle="{ background: overlayStyle }"
        :bgColor="bgColor"
        ref="$refModal"
        :closeOnClickOverlay="closeOnClickOverlay"
        @maskClick="cancle"
        :mode="mode"
        :round="round"
        :safeAreaInsetBottom="safeAreaInsetBottom"
        :duration="duration"
    >
        <slot></slot>
    </uv-popup>
</template>

<script setup>
    import { usePublicStore } from '@/stores/public';
    import { computed, ref, watch } from 'vue';
    const screen_orientation = computed(() => usePublicStore().screen_orientation);
    const $refModal = ref(null);
    const $props = defineProps({
        zIndex: {
            type: String,
            default: '999'
        },
        duration: {
            type: Number,
            default: 200
        },
        overlayStyle: {
            type: String,
            default: 'rgba(0, 0, 0, 0.2)'
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: true
        },
        mode: {
            type: String,
            default: 'center'
        },
        bgColor: {
            type: String,
            default: '#F5F3ED'
        },
        showBoo: {
            type: Boolean,
            default: false
        },
        safeAreaInsetBottom: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        callBackFun: {
            type: Function
        },
        round: {
            type: String,
            default: '20px'
        }
    });
    watch(
        () => $props.showBoo,
        () => {
            if ($props.showBoo) {
                openModal();
            } else {
                closeModal();
            }
        }
    );
    watch(
        () => screen_orientation.value,
        () => {
            $emits('update:showBoo', false);
        }
    );
    const $emits = defineEmits(['update:showBoo', 'confirm', 'close', 'cancel']);
    const openModal = () => {
        usePublicStore().setPageScorll(true);
        $refModal.value.open();
    };
    const closeModal = () => {
        $refModal.value.close();
        $emits('close', false);
    };
    const cancle = () => {
        if (!$props.closeOnClickOverlay) {
            return;
        }
        $emits('cancel');
        usePublicStore().setPageScorll(false);
        $emits('update:showBoo', false);
    };
    const confirm = () => {
        usePublicStore().setPageScorll(false);
        if (typeof $props.callBackFun == 'function') {
            return $props.callBackFun();
        } else {
            $emits('confirm');
            $emits('update:showBoo', false);
        }
    };
    defineExpose({
        closeModal,
        openModal
    });
</script>

<style lang="scss" scoped>
    .titles {
        font-size: 20px;
        color: #4f5767;
        font-weight: 600;
    }

    .btn {
        display: inline-flex;
        justify-content: space-around;
        padding-bottom: 25px;

        text {
            line-height: 35px;
            height: 35px;
            padding: 0 35px;
            border-radius: 35px;
            color: #fff;
        }

        .cancle {
            background: #c9c9c9;
        }

        .chat {
            background: $btn-color;
        }
    }
</style>
